import { vModelDynamic as _vModelDynamic, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01620537"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "passwordInput" }
const _hoisted_2 = ["type"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_eye_open = _resolveComponent("icon-eye-open")!
  const _component_icon_eye_closed = _resolveComponent("icon-eye-closed")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", _mergeProps({
      type: _ctx.showPassword ? 'text' : 'password'
    }, _ctx.$attrs, {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localValue) = $event)),
      onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit(_ctx.localValue)))
    }), null, 16, _hoisted_2), [
      [_vModelDynamic, _ctx.localValue]
    ]),
    _createElementVNode("button", {
      class: "btn btn-sm btn-secondary",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showPassword = !_ctx.showPassword))
    }, [
      (!_ctx.showPassword)
        ? (_openBlock(), _createBlock(_component_icon_eye_open, { key: 0 }))
        : (_openBlock(), _createBlock(_component_icon_eye_closed, { key: 1 }))
    ])
  ]))
}